var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layoutBase_main"}},[_c('div',{attrs:{"id":"layoutBase_top"}},[_c('top-navigation')],1),_c('div',{attrs:{"id":"layoutBase_content"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }